import React, { useContext } from 'react';
import './header.scss';
import Button from '../FormElements/Button';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/auth-context';
import { clearProfile } from '../../../redux/profile/profile-actions';
import { connect } from 'react-redux';


import {ReactComponent as Profile2} from '../../../assets/profile2.svg';
import {ReactComponent as Home2} from '../../../assets/home2.svg';
import {ReactComponent as Logout} from '../../../assets/logout.svg';
import {ReactComponent as Travel} from '../../../assets/travel.svg';

import BellIcon from './bellIcon/bellIcon';
import NotiDropdown from './notiDropdown/notiDropdown';
import Search from './search/search';
import Backdrop from '../UIElements/backdrop';
import { showNotiDropdown } from '../../../redux/notifications/notifications-actions';
import SearchDropdown from './searchDropdown/searchDropdown';
import { closeSearchResult } from '../../../redux/search/search-actions';



const Header = props => {

  const auth = useContext(AuthContext);

  const history = useHistory();

  return ( 
    
    <div className='header'>
      <div className='header-left'>
        <Search />
      </div>
      <div className='header-center'>
        <Travel className='logo12' /> 
        <h2 className='traveler-header' >Traveler</h2> 
      </div>  
      <div className='header-right'>
        <Button className='button button__main-header' 
        onClick={() => history.push('/')}>
          <Home2 className='logo-header' />
        </Button>
        
        <Button className='button button__main-header'
        onClick={() => history.push(`/p/${auth.user._id}`)}>
          <Profile2 className='logo-header' />
        </Button>

          <Button className='button button__main-header'
          style={{width: '40px'}} >
            <BellIcon />
          </Button>
          
          <Button className='button button__main-header'
          onClick={() => {
            auth.logout();
            props.clearProfile();
            history.push('/');
          }} 
          style={{width: '40px'}} >
            <Logout className='logo-header1' />
          </Button>
      </div>
      {props.showNotiDropdown1 && <NotiDropdown />}
      {props.showNotiDropdown1 && <Backdrop style={{background: 'none'}} onClick={props.showNotiDropdown} />}
      
      {props.openSearchResult && <SearchDropdown />}
      {props.openSearchResult && <Backdrop style={{background: 'none'}} onClick={props.closeSearchResult} />}
    </div>
  )
}



const mapStateToProps = state => ({
  showNotiDropdown1: state.notifications.showNotiDropdown,
  inHomepage: state.homepage.inHomepage,
  inProfilePage: state.profile.inProfilePage,
  userIdParam: state.profile.userIdParam,
  openSearchResult: state.search.openSearchResult,
});



export default connect(mapStateToProps, { clearProfile, showNotiDropdown, closeSearchResult })(Header);